import { Button, Link, PageTitle, Paragraph } from '@common/components';
import { HELIX_SUPPORT_EMAIL } from '@common/constants';

import { StyledActionsContainer, StyledContainer, StyledContent } from './common.styles';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { ErrorScreenProps } from '../types';

const ErrorScreen: FC<ErrorScreenProps> = () => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledContent>
        <PageTitle data-testid="error-page-title">{t('error_page.title')}</PageTitle>
        <Paragraph data-testid="error-page-description">
          {t('error_page.description1')}&nbsp;
          <Link to={`mailto: ${HELIX_SUPPORT_EMAIL}`}>{t('error_page.support')}</Link>
          &nbsp;{t('error_page.description2')}
        </Paragraph>
        <StyledActionsContainer>
          <Button
            id="error-page-button"
            onClick={() => {
              window.location.replace('/');
            }}
          >
            {t('error_page.action')}
          </Button>
        </StyledActionsContainer>
      </StyledContent>
    </StyledContainer>
  );
};

export default ErrorScreen;
